import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getStateAsync, XeroAsync, QBAsync, setXero, setXeroFromLocalStorage, setQB, setQBFromLocalStorage } from './IntegrationSlice';
import { updateGoogleCalendarTimesheetAutoSync, updateGoogleCalendarTaskAutoSync, updateGoogleCalendarTimesheetManualSync, updateGoogleCalendarTaskManualSync } from '../../../common/GlobalSlice'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import Loader from '../../../common/Loader';
import Select, { components } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { validateSystemIntegration, dropDownSelectionStyles } from '../../../common/timeLiveFunction';
import clsx from 'clsx';

const initialIntegration = {
    QBIsConnected: false,
    QBConsumerKey: '',
    QB_oauth_Callback_Url: '',
    QBstate: '',

    GoogleCalendarIsConnected: false,
    GoogleCalendarClientId: '',
    GoogleCalendarSecret: '',
    GoogleCalendarCallBack: '',
    GoogleCalendarState: '',
    GoogleCalendarSystemIntegrationId: '',
    CommaSeparatedCalendarIds: '',
    GoogleCalendarItems: [],
    IsTask: false,
    IsTaskManual: false,
    IsTimeSheet: false,
    IsTimeSheetManual: false,
}

export const EmployeeIntegrationModal = (props: any) => { 
    const { modelRef,  oncloseModal, employeeId } = props;
   
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const ConnectedButtonRef = useRef<any>(null);
    const [googlecalendarItemsArray, SetGooglecalendarItemsArray] = useState<any | ''>([]);
    const navigate = useNavigate();

    const googlecalendar_clientId = '746449382374-odim9bg2213d2vtg6uqmsk5atvu8b79g.apps.googleusercontent.com';
    const googlecalendar_callback_uri = 'https://localdebug.livetecs.com/Handler/Integration/GoogleCalendar.ashx';
    const googlecalendar_scope = 'https://www.googleapis.com/auth/calendar';
    const [isIntegerationConnected, setIsIntegerationConnected] = useState(initialIntegration);
    const [isLoading, setIsLoading] = useState(true);
    const { sessionAccountId, sessionAccountEmployeeId } = useAppSelector((state) => state.globalState);

    const location = useLocation();

    useEffect(() => {
        getIntegerationDataAsync();
    }, []);

    useEffect(() => {
        if (isIntegerationConnected.GoogleCalendarIsConnected) {
           
            console.log('props',props)
            if (ConnectedButtonRef.current) {
                
                ConnectedButtonRef.current.click();
                console.log('Ahmed Khokhar',ConnectedButtonRef.current.click())
            }
        }
    }, [isIntegerationConnected.GoogleCalendarIsConnected]);

    const getIntegerationDataAsync = async () => {
        try {
            const response: any = await fetchAPI(`api/v2/Integrations/QB/GetAccountIntegerations/${sessionAccountId}/${employeeId}`, "GET", "", true);
            const json = await response.json();
            let isQBConnected = json.hasOwnProperty('QBIntegration') ? (json["QBIntegration"].AccessToken != '' ? true : false) : false;
            let isGoogleCalendarConnected = json["GoogleCalendarIntegration"] ? (json["GoogleCalendarIntegration"].AccessToken != '' ? true : false) : false;
            let tempCommaSeparatedCalendarIds = json["GoogleCalendarSettings"].find((item: any) => item.Key === "CommaSeparatedCalendarIds")?.Value;
            let tempGoogleCalendarItems = ((json["GoogleCalendarList"] && json["GoogleCalendarList"].length > 0) ?
                json["GoogleCalendarList"].map((item: any) => {
                    if (tempCommaSeparatedCalendarIds.includes(item.value)) {
                        return { ...item, isSelected: 1 };
                    }
                    return item;
                }) : []);
            setIsIntegerationConnected({
                ...isIntegerationConnected,
                QBIsConnected: isQBConnected ? validateSystemIntegration(json["QBSettings"].find((item: any) => item.Key === "QBSystemIntegrationId")?.Value.toUpperCase()) === 'Quickbooks' ? true : false : false,
                QBConsumerKey: json.hasOwnProperty('QBSettings') ? json["QBSettings"].find((item: any) => item.Key === "QBConsumerKey")?.Value : '',
                QB_oauth_Callback_Url: json.hasOwnProperty('QBSettings') ? json["QBSettings"].find((item: any) => item.Key === "QBCallBack")?.Value : '',
                QBstate: json.hasOwnProperty('QBSettings') ? json["QBSettings"].find((item: any) => item.Key === "QBState")?.Value : '',
                GoogleCalendarIsConnected: isGoogleCalendarConnected ? validateSystemIntegration(json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarSystemIntegrationId")?.Value.toUpperCase()) === 'GoogleCalendar' ? true : false : false,
                GoogleCalendarClientId: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarClientId")?.Value,
                GoogleCalendarCallBack: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarCallBack")?.Value,
                GoogleCalendarState: json["GoogleCalendarSettings"].find((item: any) => item.Key === "GoogleCalendarState")?.Value,
                CommaSeparatedCalendarIds: tempCommaSeparatedCalendarIds,
                GoogleCalendarItems: tempGoogleCalendarItems,
                IsTask: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTask")?.Value,
                IsTaskManual: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTaskManual")?.Value,
                IsTimeSheet: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheet")?.Value,
                IsTimeSheetManual: json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheetManual")?.Value,
               });
            dispatch(updateGoogleCalendarTaskAutoSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTask")?.Value));
            dispatch(updateGoogleCalendarTimesheetAutoSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTaskManual")?.Value));
            dispatch(updateGoogleCalendarTaskManualSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTIsTimeSheetask")?.Value));
            dispatch(updateGoogleCalendarTimesheetManualSync(json["GoogleCalendarSettings"].find((item: any) => item.Key === "IsTimeSheetManual")?.Value));
            
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    const updateCalendarIds = async (commaSeparatedCalendarIds: any) => {
        const response = await fetchAPI(`api/v2/Integrations/updateCalendarIds`, 'PUT', { commaSeparatedCalendarIds: commaSeparatedCalendarIds }, true);
    }

    const updateIntegrationSyncAsync = async (checked: boolean, name: string) => {
        const response = await fetchAPI("api/V2/Integrations/updateIntegration/" + checked + "/" + name, "PUT", "", true, "");
    }

    const handlePropertyChange = (selectedOption: any[]) => {
        const values = selectedOption.map((option: any) => option.value.trim());
        // Create a shallow copy of GoogleCalendarItems
        const newState = [...isIntegerationConnected.GoogleCalendarItems];
        // Create a set of the selected values for fast lookup
        const selectedValuesSet = new Set(values);
        // Iterate over each item to update its selection status
        newState.forEach((item: any) => {
            // If the item's value is in the selected values, mark it as selected
            if (selectedValuesSet.has(item.value.trim())) {
                item.isSelected = 1;
            } else {
                // If the item is not in the selected values, unselect it
                item.isSelected = 0;
            }
        });
        let tempCommaSeparatedCalendarIds = newState
            .filter((item: any) => item.isSelected == 1)
            .map((item: any) => item.value)
            .join(',')
        // Update the state with the new state
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            GoogleCalendarItems: newState,
            CommaSeparatedCalendarIds: tempCommaSeparatedCalendarIds
        });
        updateCalendarIds(tempCommaSeparatedCalendarIds);
    }

    const onHandleTaskAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTask: checked
        });
        dispatch(updateGoogleCalendarTaskAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTask");
    }

    const onHandleTaskManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTaskManual: checked
        });
        dispatch(updateGoogleCalendarTaskManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTaskManual");
    }

    const onHandleTimesheetAutoSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTimeSheet: checked
        });
        dispatch(updateGoogleCalendarTimesheetAutoSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheet");
    }

    const onHandleTimesheetManualSync = (e: any) => {
        const { checked } = e.target;
        setIsIntegerationConnected({
            ...isIntegerationConnected,
            IsTimeSheetManual: checked
        });
        dispatch(updateGoogleCalendarTimesheetManualSync(checked));
        updateIntegrationSyncAsync(checked, "IsTimeSheetManual");
    }
    
    // const handleConnectGoogleCalendar = () => {
    //     //window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${isIntegerationConnected.GoogleCalendarClientId}&redirect_uri=${isIntegerationConnected.GoogleCalendarCallBack}&response_type=code&scope=${googlecalendar_scope}&access_type=offline&include_granted_scopes=true&state=${isIntegerationConnected.GoogleCalendarState}&prompt=consent`;
    //     window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${isIntegerationConnected.GoogleCalendarClientId}&redirect_uri=${isIntegerationConnected.GoogleCalendarCallBack}&response_type=code&scope=${googlecalendar_scope}&access_type=offline&include_granted_scopes=true&state=${isIntegerationConnected.GoogleCalendarState}&prompt=consent`;
    // };

    const handleConnectGoogleCalendar = () => {
        const googleAuthUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${isIntegerationConnected.GoogleCalendarClientId}&redirect_uri=${isIntegerationConnected.GoogleCalendarCallBack}&response_type=code&scope=${googlecalendar_scope}&access_type=offline&include_granted_scopes=true&state=${isIntegerationConnected.GoogleCalendarState}&prompt=consent`;
        window.open(googleAuthUrl, '_blank'); // This opens the URL in a new tab
      };
   
    return (
        <>
            {isLoading && <Loader />}
           
            <div className="modal drawer-overlay" style={{ display: 'block' }}
            >
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                        <h3 className="card-title fw-bold headerTitle pl-0">{'Employee Integrations'}</h3>
                            <div
                                className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                onClick={oncloseModal}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-1x"
                                />
                            </div>
                        </div>
                        <div className="modal-body">
                        <div className='row' style={{ padding: '20px 30px' }}>  
                           <div className="col-md-6">
                                                 <div className='card card-custom card-stretch-50 shadow mb-6' style={{ border: '1px solid rgba(189, 189, 189, 0.5)', backgroundColor: 'rgb(255 222 126 / 20%)' }}>
                                                     <div className="card-header" style={{ borderBottom: '1px solid rgb(0 0 0 / 10%)' }}>
                                                         <h3 className="card-title Gc"> {t('Google Calendar')}</h3>
                                                         <div className="card-toolbar">
                                                             <img src={toAbsoluteUrl('/media/logos/integrations/g-calendar.png')} />
                                                         </div>
                                                     </div>
                                                     <div className="card-body" style={{ height: '120px', overflow: 'scroll' }}>
                                                         {isIntegerationConnected.GoogleCalendarIsConnected &&
                                                             <>
                                                                 <div style={{ float: 'right' }}>
                                                                     <div className={clsx('cursor-pointer symbol')}
                                                                         data-kt-menu-trigger="{default: 'click'}"
                                                                         data-kt-menu-attach='parent'
                                                                         data-kt-menu-placement='bottom-end'
                                                                     >
                                                                         <span
                                                                             className={`btn btn-icon btn-active-light-dark '}   btn-sm ms-0 fs-7`}
                                                                             data-tooltip-id="tooltip-Description"
                                                                             data-tooltip-content="Integration Settings"
                                                                             data-tooltip-place="bottom"
                                                                         >
                                                                             <i className="bi bi-gear fs-3 Gc" ></i>
                                                                         </span>
                                                                     </div>
                                                                     <div className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary py-4 fs-6 w-350px`}
                                                                         data-kt-menu='true'
                                                                     >
                                                                         <div className={"row tsDescriptionWidget "}>
                                                                             <div className={"col-md-12 col-sm-12 col-xs-12"}>
                                                                                 <h4 className="card-title fw-bold titleHeading">{t(`Integration Settings`)}</h4>
                                                                                 <div className="separator my-2"></div>
                                                                                 <div className="mb-2 col-md-12 col-xs-12">
                                                                                     <div className="row col-md-12 col-xs-12 mb-1">
                                                                                         <div className="col-md-9">
                                                                                             <label className="fs-7 fs-7 fw-normal">Calendar List</label>
                                                                                         </div>
                                                                                     </div>
                                                                                     <Select
                                                                                         value={isIntegerationConnected.GoogleCalendarItems.filter((item: any) => item.isSelected == 1).map((item: any) => ({ value: item.value, label: item.label }))}
                                                                                         closeMenuOnSelect={false}
                                                                                         options={isIntegerationConnected.GoogleCalendarItems}
                                                                                         isMulti
                                                                                         onChange={(selectedOptions: any) =>
                                                                                             handlePropertyChange(selectedOptions)
                                                                                         }
                                                                                         components={{ MultiValue }}
                                                                                         hideSelectedOptions={false}
                                                                                         styles={dropDownSelectionStyles}
                                                                                         maxMenuHeight={maxMenuHeight}
                                                                                     />
                                                                                 </div>
                                                                                 <span className='fw-bold'>{t(`Timesheet`)}</span>
                                                                                 <div className="separator my-2"></div>
                                                                                 <div className="row mb-2 col-md-12">
                                                                                     <div className='col-md-6'>
                                                                                         <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                                         <div className={"form-group"}>
                                                                                             <div className="form-check form-switch form-check-custom">
                                                                                                 <input
                                                                                                     type="checkbox"
                                                                                                     className="form-check-input custom-padding-right h-15px w-30px"
                                                                                                     //checked={isGoogleCalendarTimesheetAutoSync}
                                                                                                     checked={isIntegerationConnected.IsTimeSheet}
                                                                                                     onChange={(e) => { onHandleTimesheetAutoSync(e) }}
                                                                                                 />
                                                                                             </div>
                                                                                         </div>
                                                                                     </div>
                                                                                     <div className='col-md-6'>
                                                                                         <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                                         <div className={"form-group"}>
                                                                                             <div className="form-check form-switch form-check-custom">
                                                                                                 <input
                                                                                                     type="checkbox"
                                                                                                     className="form-check-input custom-padding-right h-15px w-30px"
                                                                                                     // checked={isGoogleCalendarTimesheetManualSync}
                                                                                                     checked={isIntegerationConnected.IsTimeSheetManual}
                                                                                                     onChange={(e) => { onHandleTimesheetManualSync(e) }}
                                                                                                 />
                                                                                             </div>
                                                                                         </div>
                                                                                     </div>
                                                                                 </div>
                                                                                 <span className='fw-bold'>{t(`Task`)}</span>
                                                                                 <div className="separator my-2"></div>
                                                                                 <div className="row mb-2 col-md-12">
                                                                                     <div className='col-md-6'>
                                                                                         <label className="fs-7 fs-7 fw-normal mb-1">{t('Auto')}</label>
                                                                                         <div className={"form-group"}>
                                                                                             <div className="form-check form-switch form-check-custom">
                                                                                                 <input
                                                                                                     type="checkbox"
                                                                                                     className="form-check-input custom-padding-right h-15px w-30px"
                                                                                                     //checked={isGoogleCalendarTaskAutoSync}
                                                                                                     checked={isIntegerationConnected.IsTask}
                                                                                                     onChange={(e) => { onHandleTaskAutoSync(e) }}
                                                                                                 />
                                                                                             </div>
                                                                                         </div>
                                                                                     </div>
                                                                                     <div className='col-md-6'>
                                                                                         <label className="fs-7 fs-7 fw-normal mb-1">{t('Manual')}</label>
                                                                                         <div className={"form-group"}>
                                                                                             <div className="form-check form-switch form-check-custom">
                                                                                                 <input
                                                                                                     type="checkbox"
                                                                                                     className="form-check-input custom-padding-right h-15px w-30px"
                                                                                                     // checked={isGoogleCalendarTaskManualSync}
                                                                                                     checked={isIntegerationConnected.IsTaskManual}
                                                                                                     onChange={(e) => { onHandleTaskManualSync(e) }}
                                                                                                 />
                                                                                             </div>
                                                                                         </div>
                                                                                     </div>
                                                                                 </div>
                                                                             </div>
                                                                         </div>
                                                                     </div>
                         
                                                                 </div>
                                                                 <p className="connected Gc">
                                                                     <i className="fa fa-check Gc" style={{ color: '#0f6f85', fontSize: '20px' }} aria-hidden="true"> </i>&nbsp;{t("You 're connected")}
                                                                 </p>
                                                             </>
                                                         }
                                                         <p className="desc"> {t('Google Calendar lets you organize your Company schedule and share events with co-workers and Employees.')}</p>
                                                     </div>
                                                     {/* <div className="card-footer">
                                            {!isIntegerationConnected.GoogleCalendarIsConnected ? (
                                                <button
                                                    className='btn btn-sm'
                                                    style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                                    onClick={handleConnectGoogleCalendar}
                                                >
                                                    <span style={{ verticalAlign: '0.2em' }}> {t('Connect to Google Calendar')}</span>
                                                </button>
                                            ) : (
                                                <button
                                                    className='btn btn-sm'
                                                    style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                                    ref={ConnectedButtonRef}
                                                >
                                                    <span style={{ verticalAlign: '0.2em' }}> {t('Connected')}</span>
                                                </button>
                                            )}
                                        </div> */}
                                                     <div className="card-footer">
                                                         {!isIntegerationConnected.GoogleCalendarIsConnected ?
                                                             <Link to={`https://accounts.google.com/o/oauth2/v2/auth?client_id=${isIntegerationConnected.GoogleCalendarClientId}&redirect_uri=${isIntegerationConnected.GoogleCalendarCallBack}&response_type=code&scope=${googlecalendar_scope}&access_type=offline&include_granted_scopes=true&state=${isIntegerationConnected.GoogleCalendarState}&prompt=consent`}
                                                                 className='btn btn-sm'
                                                                 style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                                             >
                                                                 <span style={{ verticalAlign: '0.2em' }}>  {t('Connect to Google Calendar')}</span>
                                                             </Link>
                                                             :
                                                             <Link to={` `}
                                                                 className='btn btn-sm'
                                                                 style={{ background: 'rgb(117 87 0 / 79%)', color: 'white', opacity: '0.7' }}
                                                                ref={ConnectedButtonRef}
                                                             >
                                                                 <span style={{ verticalAlign: '0.2em' }}> {t('Connected')}</span>
                                                             </Link>
                                                            
                                                         }
                                                     </div>
                                                 </div>
                                             </div>  
                                                        
                        
                        </div>
                        </div>
                    </div>
                </div>
            </div>








        </>
    )
}

const MultiValue = ({ index, getValue, ...props }: any) => {
    const maxToShow = 0;
    const overflow = getValue()
        .slice(maxToShow)
        .map((x: any) => x.label);
    return index < maxToShow ? (
        <components.MultiValue {...props} />
    ) : index === maxToShow ? (
        <>
            <MoreSelectedBadge items={overflow} totalItemCount={props.options.length} />
        </>
    ) : null;
};
const MoreSelectedBadge = ({ items, totalItemCount }: any) => {
    const style = {
        background: "#d4eefa",
        borderRadius: "4px",
        fontSize: "12px",
        padding: "5px"
    };
    const title = items.join(", ");
    const length = items.length;
    const label = length === totalItemCount ? `All Selected(${length})` : ` ${length} Item${length !== 1 ? "s" : ""} Selected`;
    return (
        <div style={style} title={title}>
            {label}
        </div>
    );
};